<template>
  <div :class="className">
    <!-- <button @click="undo">撤销</button> -->
    <div class="butterfly-vue-container" ref="canvas-dag">
      <div class="butterfly-progress">{{percentage}}%</div>
    </div>
  </div>
</template> 
<script>
import "butterfly-dag/dist/index.css";
import { Canvas } from "butterfly-dag";
import { processNodes, processEdge, processGroups } from "./process.js";
import recalc from "./re-calc.js";
import relayout from "./re-layout.js";
const defaultOptions = {
  // disLinkable: false, // 可修改连线
  zoomable: true, // 可放大
  moveable: true, // 可平移
  // setSelectMode: true, //对齐线
  zoomGap: 1,
  theme: {
    group: {
      type: "normal" //节点组类型(选填): normal(随意拖入拖出),inner(只能拖入不能拖出)
    },
    edge: {
      arrow: true, //线条默认是否带箭头
      color: "purple",
      arrowPosition: 0.99,
      shapeType: "Manhattan", // Manhattan Straight
      isExpandWidth: false //增加线条交互区域
    },
    endpoint: {
      // position: ['Top', 'Bottom', 'Left', 'Right'], //限制锚点位置['Top', 'Bottom', 'Left', 'Right'],
      linkableHighlight: true, //连线时会触发point.linkable的方法，可做高亮
      limitNum: 999, //限制锚点的连接数目
      expandArea: {
        //锚点过小时，可扩大连线热区
        left: 20,
        right: 20,
        top: 30,
        botton: 10
      }
    }
  }
};
export default {
  name: "butterfly-vue",
  props: {
    className: {
      type: String,
      default: "butterfly-vue"
    },
    //是否可连线
    linkable: {
      type: Boolean,
      default: false
    },
    //是否可拖动节点
    draggable: {
      type: Boolean,
      default: false
    },
    baseCanvas: {
      type: Function,
      default: Canvas
    },
    // canvasConf: {
    //   type: Object,
    //   default: () => {
    //     return defaultOptions;
    //   }
    // },
    canvasData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      percentage: 100,
      showGrid: false,
      canvas: null,
      nodes: this.canvasData.nodes,
      groups: this.canvasData.groups,
      edges: this.canvasData.edges
    };
  },
  watch: {
    groups: {
      handler() {
        this.updateCavans();
        this.re();
      }
    },
    nodes: {
      handler() {
        this.updateCavans();
        this.re();
      }
    },
    edges: {
      handler() {
        this.updateCavans();
        this.re();
      }
    },
    canvasData: {
      handler() {
        this.nodes = this.canvasData.nodes;
        this.groups = this.canvasData.groups;
        this.edges = this.canvasData.edges;
      }
    }
  },
  mounted() {
    this.initCanvas();
    if (!this.canvas) {
      console.warn("当前canvas为null，初始化存在问题");
      return;
    }
    this.updateCavans();
    this.re();
    this.$emit("onLoaded", this);
    this.canvas.on("events", data => {
      //监听画布行为
      if (data.type != "drag:move" && data.type != "system.canvas.move") {
      }
      //放大缩小时计算比例
      if (data.type == "canvas.zoom") {
        this.getPercentage(data.zoom);
      }
      if (data.type === "link:connect") {
        this.onCreateEdge(data);
      } else if (data.type === "links:delete" && data.links.length > 0) {
        this.onDeleteEdge(data);
      } else if (data.type === "link:reconnect") {
        this.onChangeEdges(data);
      } else if (data.type === "link:click") {
        this.onclickEdges(data);
      } else {
        if (data.type === "drag:end") {
          let { dragGroup, dragNode } = data;
          if (dragGroup !== null) {
            let groupIndex = this.groups.findIndex(item => {
              return item.id === dragGroup.id;
            });
            if (groupIndex !== -1) {
              this.groups[groupIndex].left = dragGroup.left;
              this.groups[groupIndex].top = dragGroup.top;
            }
            this.canvasData.groups = this.groups;
          }

          if (dragNode !== null && Array.isArray(this.nodes)) {
            let nodeIndex = this.nodes.findIndex(item => {
              return item.id === dragNode.id;
            });
            if (nodeIndex !== -1) {
              this.nodes[nodeIndex].left = dragNode.left;
              this.nodes[nodeIndex].top = dragNode.top;
            }
            this.canvasData.nodes = this.nodes;
          }
        }
        this.onOtherEvent(data);
      }
    });
    // window.canvas = this.canvas;
  },
  methods: {
    // 初始化
    initCanvas() {
      let that = this;
      this.canvas = new Canvas({
        root: this.$refs["canvas-dag"],
        linkable: that.linkable,
        draggable: that.draggable,
        ...defaultOptions
      });
      // 有效范围 0.25-5
      this.canvas.zoom(1); //设置默认放大比例
      this.drawCanvas();
    },
    drawCanvas() {
      this.canvas.draw([], () => {
        this.canvas.setGridMode(true, {
          isAdsorb: true, // 是否自动吸附,默认关闭
          theme: {
            shapeType: "circle", // 展示的类型，支持line & circle
            gap: 40, // 网格间隙
            background: "#FFF", // 网格背景颜色
            lineColor: "rgb(0, 0, 0 ,0.2)",
            lineWidth: 0.2,
            circleRadiu: 1.5, // 圆点半径
            circleColor: "rgb(234 234 234)"
          }
        });
        // this.canvas.setGuideLine(true, {
        //   limit: 1, // 限制辅助线条数
        //   theme: {
        //     lineColor: "red", // 网格线条颜色
        //     lineWidth: 1 // 网格粗细
        //   }
        // });
      });
    },
    //设置缩略图
    setMinimap() {
      this.$nextTick(() => { 
        this.canvas.setMinimap(true, {
          width: 110,
          height: 110,
          zoom: 50,
          nodeColor: "#D0E4FF",
          //缩略图颜色
          backgroudStyle: {
            background: "rgba(208, 228, 255, 0.3)"
          },
          //视口颜色
          viewportStyle: {
            background: "rgba(208, 228, 255, 0.5)"
          }
        });
      });
    },
    stopMinmap() { 
      this.canvas.setMinimap(false);
    },
    //计算画布大小比例
    getPercentage(step) {
      this.percentage = (step.toFixed(2) * 100).toFixed(0);
    },
    // 更新画布信息
    updateCavans() {
      if (!this.canvas) {
        console.warn("当前canvas为null，初始化存在问题");
        return;
      }
      const oldNodes = this.canvas.nodes;
      const oldEdges = this.canvas.edges;
      const oldGroups = this.canvas.groups;

      processGroups(this.canvas, this.groups, oldGroups, this);
      processNodes(this.canvas, this.nodes, oldNodes, this);
      processEdge(this.canvas, this.edges, oldEdges, this); 
    },

    // 重新计算节点和边的位置
    re() {
      if (!this.canvas) {
        console.warn("当前canvas为null，初始化存在问题");
        return;
      }

      recalc(this.canvas);
      relayout(this.canvas);
    },

    // 重绘所有节点
    redraw() {
      const oldNodes = this.canvas.nodes;
      const oldEdges = this.canvas.edges;
      const oldGroups = this.canvas.groups;

      processEdge(this.canvas, [], oldEdges, this);
      processNodes(this.canvas, [], oldNodes, this);
      processGroups(this.canvas, [], oldGroups, this);

      processGroups(this.canvas, this.groups, oldGroups, this);
      processNodes(this.canvas, this.nodes, oldNodes, this);
      processEdge(this.canvas, this.edges, oldEdges, this);
      this.re();
    },
    //创建线
    onCreateEdge(data) {
      let link = data.links[0];
      if (link) {
        // let edgeInfo = {
        //   id: `${link.sourceNode.id}.${link.sourceEndpoint.id}-${link.targetNode.id}.${link.targetEndpoint.id}`,
        //   sourceEndpointId: link.sourceEndpoint.id,
        //   sourceNodeId: link.sourceNode.id,
        //   targetEndpointId: link.targetEndpoint.id,
        //   targetNodeId: link.targetNode.id
        // };
        //  this.edges.push({
        //   id: `${edgeInfo.sourceNodeId}.${edgeInfo.sourceEndpointId}-${edgeInfo.targetNodeId}.${edgeInfo.targetEndpointId}`,
        //   sourceNode: edgeInfo.sourceNodeId,
        //   targetNode: edgeInfo.targetNodeId,
        //   source: edgeInfo.sourceEndpointId,
        //   target: edgeInfo.targetEndpointId
        // });
        let edgeInfo = {
          id: `${link.sourceNode.id}.${link.sourceEndpoint.id}-${link.targetNode.id}.${link.targetEndpoint.id}`,
          source: link.sourceEndpoint.id,
          sourceNode: link.sourceNode.id,
          target: link.targetEndpoint.id,
          targetNode: link.targetNode.id
        };
        this.edges.push(edgeInfo);
        //处理连线限制
        this.$emit("onCreateEdge", edgeInfo);
      }
    },

    onDeleteEdge(data) {
      let link = data.links[0];
      // this.canvas.removeEdges([link.id]);
      if (link) {
        let edgeInfo = {
          id: link.id,
          sourceEndpointId: link.sourceEndpoint.id,
          sourceNodeId: link.sourceNode.id,
          targetEndpointId: link.targetEndpoint.id,
          targetNodeId: link.targetNode.id
        };
        let index = this.edges.findIndex(item => {
          return item.id === link.id;
        });
        debugger;
        this.edges.splice(index, 1);
        //需要入队列记录
        this.$emit("onDeleteEdge", edgeInfo);
      }
    },
    //API
    // canvas.getDataMap (data, calllback) 获取画布的所有数据：节点，线段，分组
    //canvas.getNeighborEdges (string) 根据node id获取相邻的edge
    onDeleteNode(data) {
      this.canvas.removeNodes(["1.bottom-2.top", "2.right-f2880150-8b31.top"]);
    },
    // addNode(data) {
    //   this.canvas.addNode(data);
    // },
    undo() {
      this.canvas.undo();
    },
    onclickEdges(data) {
      this.$emit("onclickEdge", data);
    },
    undo() {
      this.canvas.undo();
    },
    onChangeEdges(data) {
      //修改线
      let addLinkData = data.addLinks[0];
      let delLinkData = data.delLinks[0];
      if (addLinkData && delLinkData) {
        let edgeInfo = {
          addLink: {
            id: `${addLinkData.sourceNode.id}.${addLinkData.sourceEndpoint.id}-${addLinkData.targetNode.id}.${addLinkData.targetEndpoint.id}`,
            sourceEndpointId: addLinkData.sourceEndpoint.id,
            sourceNodeId: addLinkData.sourceNode.id,
            targetEndpointId: addLinkData.targetEndpoint.id,
            targetNodeId: addLinkData.targetNode.id
          },
          delLinks: {
            id: `${delLinkData.sourceNode.id}.${delLinkData.sourceEndpoint.id}-${delLinkData.targetNode.id}.${delLinkData.targetEndpoint.id}`,
            sourceEndpointId: delLinkData.sourceEndpoint.id,
            sourceNodeId: delLinkData.sourceNode.id,
            targetEndpointId: delLinkData.targetEndpoint.id,
            targetNodeId: delLinkData.targetNode.id
          },
          info: data.info
        };

        let index = this.edges.findIndex(item => {
          return item.id === edgeInfo.delLinks.id;
        });
        this.edges.splice(index, 1);
        this.edges.push({
          id: `${addLinkData.sourceNode.id}.${addLinkData.sourceEndpoint.id}-${addLinkData.targetNode.id}.${addLinkData.targetEndpoint.id}`,
          sourceNode: edgeInfo.addLink.sourceNodeId,
          targetNode: edgeInfo.addLink.targetNodeId,
          source: edgeInfo.addLink.sourceEndpointId,
          target: edgeInfo.addLink.targetEndpointId
        });
        this.$emit("onChangeEdges", edgeInfo);
      }
    },

    onOtherEvent(data) {
      this.$emit("onOtherEvent", data);
    }
  }
};
</script>
<style>
.butterfly-minimap-container {
  border: none !important;
}
.butterflie-circle-endpoint.linkable {
  background: #1a7bfc;
}
</style>
<style scope>
.butterfly-vue-container {
  height: 100%;
  min-height: 500px;
  min-width: 300px;
  position: relative;
}
.butterfly-node {
  position: absolute;
  user-select: none;
}
.butterfly-progress {
  position: absolute;
  width: 50px;
  line-height: 26px;
  text-align: center;
  border-radius: 20px;
  right: 40px;
  bottom: 50px;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  z-index: 990;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.butterflies-link {
  stroke: rgb(228, 226, 226);
  stroke-width: 2px;
  cursor: pointer;
}
</style>
